/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetailerBillingStop
 */
export interface RetailerBillingStop {
    /**
     * 
     * @type {RetailerBillingStopKeyEnum}
     * @memberof RetailerBillingStop
     */
    key: RetailerBillingStopKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof RetailerBillingStop
     */
    reason: string;
    /**
     * 
     * @type {Date}
     * @memberof RetailerBillingStop
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof RetailerBillingStop
     */
    validUntil?: Date;
}


/**
 * @export
 */
export const RetailerBillingStopKeyEnum = {
    BillingStopOverduePayment: 'BILLING_STOP_OVERDUE_PAYMENT',
    BillingStopPaymentAdaption: 'BILLING_STOP_PAYMENT_ADAPTION',
    BillingStopTemporaryAbsence: 'BILLING_STOP_TEMPORARY_ABSENCE',
    BillingStopOthers: 'BILLING_STOP_OTHERS',
    BillingStopUnknown: 'BILLING_STOP_UNKNOWN'
} as const;
export type RetailerBillingStopKeyEnum = typeof RetailerBillingStopKeyEnum[keyof typeof RetailerBillingStopKeyEnum];


/**
 * Check if a given object implements the RetailerBillingStop interface.
 */
export function instanceOfRetailerBillingStop(value: object): value is RetailerBillingStop {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function RetailerBillingStopFromJSON(json: any): RetailerBillingStop {
    return RetailerBillingStopFromJSONTyped(json, false);
}

export function RetailerBillingStopFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetailerBillingStop {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'reason': json['reason'],
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'validUntil': json['validUntil'] == null ? undefined : (new Date(json['validUntil'])),
    };
}

export function RetailerBillingStopToJSON(json: any): RetailerBillingStop {
    return RetailerBillingStopToJSONTyped(json, false);
}

export function RetailerBillingStopToJSONTyped(value?: RetailerBillingStop | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'reason': value['reason'],
        'validFrom': value['validFrom'] == null ? value['validFrom'] : value['validFrom'].toISOString(),
        'validUntil': value['validUntil'] == null ? value['validUntil'] : value['validUntil'].toISOString(),
    };
}

